import React from 'react'
import {
  Button,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import {get, union} from 'lodash'
import {toast} from 'react-toastify'
import PropTypes from 'prop-types'
import SearchSKU from './SearchSKU'
import {NO_IMAGE_AVAL_SRC} from '../../../../../../constant'

class ShippingMethodModal extends React.Component {
  static getDerivedStateFromProps(props, state) {
    const shippingRule = get(props, 'shippingRule', null)
    const selectedItems = props.skuIdExistInShippingMethod.EXPRESS.filter(
      id => {
        return props.skuIdExistInShippingMethod.STANDARD.includes(id)
      },
    )

    if (props.open !== state.isOpen && shippingRule) {
      return {
        shippingRule: {...shippingRule},
        productSKUs: [...shippingRule.productSKUs],
        isOpen: true,
        isError: false,
        selectedItems,
      }
    }
    if (props.open !== state.isOpen) {
      return {
        isError: false,
        isOpen: true,
        shippingRule: {
          calculateType: '',
          method: '',
          pricePerUnit: '',
          fixedPrice: '',
          minimumPrice: '',
        },
        productSKUs: [],
        selectedItems,
      }
    }
    return null
  }

  state = {
    isError: false,
    isOpen: false,
    shippingRule: {
      calculateType: '',
      method: '',
      pricePerUnit: '',
      fixedPrice: '',
      minimumPrice: '',
    },
    productSKUs: [],
    selectedItems: [],
  }

  verifyBeforeSave = () => {
    const {
      id,
      calculateType,
      method,
      pricePerUnit,
      minimumPrice,
      fixedPrice,
    } = this.state.shippingRule

    const computePricePerUnit = parseFloat(pricePerUnit)
    const computeMinimumPrice = parseFloat(minimumPrice)
    const computeFixedPrice = parseFloat(fixedPrice)

    if (calculateType === '') {
      this.setState({isError: true})
      toast.error('Please select shipping rule', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (method === '') {
      this.setState({isError: true})
      toast.error('Please select shipping method', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (pricePerUnit === '' && calculateType === 'UNIT_PRICE') {
      this.setState({isError: true})
      toast.error('Please add price per unit', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (minimumPrice === '' && calculateType === 'UNIT_PRICE') {
      this.setState({isError: true})
      toast.error('Please add minimum price', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (fixedPrice === '' && calculateType === 'FIXED_PRICE') {
      this.setState({isError: true})
      toast.error('Please add fixed price', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (
      (calculateType === 'UNIT_PRICE' &&
        // eslint-disable-next-line no-restricted-globals
        (isNaN(computePricePerUnit) || isNaN(computeMinimumPrice))) ||
      // eslint-disable-next-line no-restricted-globals
      (calculateType === 'FIXED_PRICE' && isNaN(computeFixedPrice))
    ) {
      this.setState({isError: true})
      toast.error('Price must be number', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (
      (calculateType === 'UNIT_PRICE' &&
        (computePricePerUnit < 0 || computeMinimumPrice < 0)) ||
      (calculateType === 'FIXED_PRICE' && computeFixedPrice < 0)
    ) {
      this.setState({isError: true})
      toast.error('Price can not be negative', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (!this.state.productSKUs.length) {
      this.setState({isError: true})
      toast.error('Rule should have at least 1 SKU', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    if (
      this.state.productSKUs
        .map(sku => sku.id)
        .some(r => this.props.skuIdExistInShippingMethod[method].includes(r)) &&
      !this.props.shippingRule
    ) {
      this.setState({isError: true})
      toast.error('SKU can have only 1 rule', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      throw new Error('verify failed')
    }
    this.setState({isError: false})
    const idOrNotId = {id}
    return {
      shippingDetail: {
        ...idOrNotId,
        calculateType,
        method,
        pricePerUnit:
          calculateType === 'UNIT_PRICE' ? computePricePerUnit : null,
        minimumPrice:
          calculateType === 'UNIT_PRICE' ? computeMinimumPrice : null,
        fixedPrice: calculateType === 'FIXED_PRICE' ? computeFixedPrice : null,
      },
      productSKUIds: this.state.productSKUs.map(SKU => {
        return SKU.id
      }),
    }
  }

  handleUpdateShippingMethod = event => {
    if (event.target.name === 'method') {
      this.setState(prevState => ({
        ...prevState,
        shippingRule: {
          ...prevState.shippingRule,
          [event.target.name]: event.target.value,
        },
        selectedItems: union(
          this.props.skuIdExistInShippingMethod[event.target.value],
          this.state.productSKUs.map(SKU => SKU.id),
        ),
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        shippingRule: {
          ...prevState.shippingRule,
          [event.target.name]: event.target.value,
        },
      }))
    }
  }

  handleChangeSpecific = name => event => {
    this.handleUpdateShippingMethod({
      target: {
        name,
        value: event.target.checked,
      },
    })
  }

  handleTextFieldEvent = event => {
    this.handleUpdateShippingMethod({
      target: {
        name: event.target.name,
        value: event.target.value,
      },
    })
  }

  addSKUtoList = SKU => {
    this.setState({
      productSKUs: [...this.state.productSKUs, SKU],
      selectedItems: [...this.state.selectedItems, SKU.id],
    })
  }

  handleSave = async () => {
    let verifiedShippingRule
    try {
      verifiedShippingRule = this.verifyBeforeSave()
      this.setState({
        isOpen: false,
      })
      this.props.handleClose()
    } catch (e) {
      return
    }
    try {
      await this.props.onSave({
        variables: {
          projectId: this.props.projectId,
          shippingDetail: verifiedShippingRule.shippingDetail,
          productSKUIds: verifiedShippingRule.productSKUIds,
        },
      })
    } catch (e) {
      const gqlError = get(e, 'graphQLErrors[0].message')
      if (gqlError) {
        toast.error(gqlError, {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      } else {
        toast.error('Some error occur.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      }
    }
  }

  render() {
    const {shippingRule, productSKUs} = this.state
    return (
      <Dialog
        scroll="body"
        maxWidth="lg"
        onClose={() => {
          this.setState({
            isOpen: false,
          })
          this.props.handleClose()
        }}
        open={this.props.open}
        classes={{paper: 'paper-no-overflow'}}
      >
        <DialogTitle>
          {get(this.props, 'shippingRule', null) ? 'Edit' : 'Add'} Shipping rule
        </DialogTitle>
        <DialogContent classes={{root: 'paper-no-overflow'}}>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <div style={{display: 'flex', alignItems: 'center'}}>Type</div>
            <Select
              error={this.state.isError && !shippingRule.calculateType}
              value={shippingRule.calculateType}
              onChange={this.handleUpdateShippingMethod}
              displayEmpty
              name="calculateType"
              style={{marginLeft: 100}}
            >
              <MenuItem value="">
                <em>Select Shipping Calculate Type</em>
              </MenuItem>
              <MenuItem value="UNIT_PRICE">Unit per price</MenuItem>
              <MenuItem value="FIXED_PRICE">Fixed price</MenuItem>
            </Select>
          </div>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Products
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: 69,
                padding: 5,
              }}
            >
              <SearchSKU
                projectId={this.props.projectId}
                onSelectSKU={this.addSKUtoList}
                selectedItemIDs={this.state.selectedItems}
                remark="สินค้าที่มีวิธีการจัดส่งครบแล้วจะไม่ถูกแสดงเวลาค้นหา"
              />
            </div>
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell align="right">Product Name</TableCell>
                <TableCell align="right">SKU Code</TableCell>
                <TableCell align="right">SKU value</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productSKUs.map((currentSKU, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      <img
                        style={{width: 64, height: 64}}
                        alt=""
                        src={
                          currentSKU.image.src
                            ? currentSKU.image.src
                            : NO_IMAGE_AVAL_SRC
                        }
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {currentSKU.product.name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {currentSKU.productCode}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {(get(currentSKU, 'productType') || []).map(
                        (productType, i) => (
                          <span
                            style={{display: 'block'}}
                            key={productType.key.key}
                          >
                            {productType.key.key}: {productType.value}
                          </span>
                        ),
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: 'red',
                          color: 'white ',
                        }}
                        onClick={() => {
                          this.setState({
                            productSKUs: this.state.productSKUs.filter(
                              (e, indexSKU) => index !== indexSKU,
                            ),
                            selectedItems: this.state.selectedItems.filter(
                              id => id !== currentSKU.id,
                            ),
                          })
                        }}
                      >
                        Remove
                      </Button>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
          {(() => {
            if (shippingRule.calculateType === 'UNIT_PRICE') {
              return (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '5px 0',
                    }}
                  >
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      ราคาค่าส่งต่อชิ้น
                    </div>
                    <TextField
                      error={this.state.isError && !shippingRule.pricePerUnit}
                      name="pricePerUnit"
                      value={shippingRule.pricePerUnit}
                      onChange={this.handleTextFieldEvent}
                      style={{marginLeft: 105}}
                      required
                    />
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      บาท
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      paddingTop: 5,
                    }}
                  >
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      ราคาเหมาส่งเมื่อสั่งซื้อไม่เกิน
                    </div>
                    <TextField
                      error={this.state.isError && !shippingRule.pricePerUnit}
                      name="minimumPrice"
                      value={shippingRule.minimumPrice}
                      onChange={this.handleTextFieldEvent}
                      style={{marginLeft: 37}}
                      required
                    />
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      บาท
                    </div>
                  </div>
                </div>
              )
            }
            if (shippingRule.calculateType === 'FIXED_PRICE') {
              return (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      padding: '5px 0',
                    }}
                  >
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      ราคาเหมาส่งทั้งหมด
                    </div>
                    <TextField
                      error={this.state.isError && !shippingRule.fixedPrice}
                      name="fixedPrice"
                      value={shippingRule.fixedPrice}
                      onChange={this.handleTextFieldEvent}
                      style={{marginLeft: 84}}
                      required
                    />
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      บาท
                    </div>
                  </div>
                </div>
              )
            }
            return <div />
          })()}
          <div style={{display: 'flex', flexDirection: 'row', paddingTop: 5}}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              Shipping Method
            </div>
            <Select
              error={this.state.isError && !shippingRule.method}
              value={shippingRule.method}
              onChange={this.handleUpdateShippingMethod}
              displayEmpty
              name="method"
              style={{marginLeft: 95}}
            >
              <MenuItem value="">
                <em>Select Shipping Method</em>
              </MenuItem>
              <MenuItem value="STANDARD">Standard</MenuItem>
              <MenuItem value="EXPRESS">Express</MenuItem>
            </Select>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.handleSave}
            style={{color: '#663EE8'}}
            color="primary"
          >
            Save
          </Button>
          <Button
            onClick={() => {
              this.setState({
                isOpen: false,
              })
              this.props.handleClose()
            }}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

ShippingMethodModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  shippingRule: PropTypes.object,
  skuIdExistInShippingMethod: PropTypes.object.isRequired,
}

export default ShippingMethodModal



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/shipping/components/ShippingMethodModal.js